import { MarginBottom } from '../styles';
import { Flex } from 'shared/ui/flex';
import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { CheckboxList } from 'shared/ui/checkbox';
import { FC } from 'react';
import { OrderCheckboxFiltersProps } from '../types';

export const OrderCheckboxFilters: FC<OrderCheckboxFiltersProps> = ({
	places,
	selectedPlacesCheckbox,
	selectedStatusCheckbox,
	changePlacesCheckbox,
	changeStatusCheckbox,
}) => {
  const Label = withTypographyContainer(Typography);

	return (
		<MarginBottom>
			<Flex $justify="space-between">
				<div>
					<Label colorVariant={'main'} isBold={true}>
						Зал
					</Label>
					<CheckboxList
						multi={true}
						checkboxes={places}
						changeCheckboxes={changePlacesCheckbox}
						defaultValue={selectedPlacesCheckbox}
					/>
				</div>

				<div>
					<Label colorVariant={'main'} isBold={true}>
						Статус
					</Label>
					<CheckboxList
						checkboxes={[
							{
								id: 'appointed',
								name: 'Забронировано',
							},
							{
								id: 'visit_started',
								name: 'Гости пришли',
							},
							{
								id: 'visit_ended',
								name: 'Гости ушли',
							},
							{
								id: 'visit_missed',
								name: 'Гости не пришли',
							},
							{
								id: 'cancelled',
								name: 'Отменено',
							},
						]}
						multi={true}
						changeCheckboxes={changeStatusCheckbox}
						defaultValue={selectedStatusCheckbox}
					/>
				</div>
			</Flex>
		</MarginBottom>
	);
};
